module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "patrimonial-form"
  }, [_c('form', {
    staticClass: "form-ui landscape-patrimonial-ui",
    attrs: {
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tQuel est votre horizon d'investissements ? (1 réponse possible)\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.perspectives,
      "selected": _vm.perspective
    },
    on: {
      "change": function($event) {
        _vm.perspective = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tQuels sont vos objectifs d'investissement prioritaires ? (plusieurs réponses possibles)\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-tags row"
  }, _vm._l((_vm.objectives), function(tag, key) {
    return _c('div', {
      key: key,
      staticClass: "tag",
      class: {
        active: _vm.isActiveTag(tag)
      },
      on: {
        "click": function($event) {
          return _vm.toggleTag(tag)
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(tag) + "\n\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tQuel degrès de risque êtes-vous prêt à accepter pour atteindre vos objectifs ? (1 réponse possible)\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.riskDegrees,
      "selected": _vm.riskDegree
    },
    on: {
      "change": function($event) {
        _vm.riskDegree = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tEn cas d'investissement sur les marchés financiers quel niveau de hausse aimeriez vous atteindre ?\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.risingMarkets,
      "selected": _vm.risingMarket
    },
    on: {
      "change": function($event) {
        _vm.risingMarket = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tSelon le paysage patrimonial que vous venez de décrire l'estimation de votre patrimoine global se situe ?\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.assetsEstimates,
      "selected": _vm.assetsEstimate
    },
    on: {
      "change": function($event) {
        _vm.assetsEstimate = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })]), _vm._v(" "), _c('div', {
    staticClass: "label solo"
  }, [_vm._v("\n\t\t\tSi vous deviez effectuer un nouvel investissement, que représenterait ce montant au regard de votre patrimoine global ?\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "form-elem-container row"
  }, [_c('div', {
    staticClass: "ctn-input"
  }, [_c('custom-select', {
    attrs: {
      "solo": true,
      "items": _vm.investmentsEstimates,
      "selected": _vm.investmentsEstimate
    },
    on: {
      "change": function($event) {
        _vm.investmentsEstimate = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-145584b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/MyPatrimonialLandscape/Perspective.vue
// module id = 1074
// module chunks = 0